import { useState } from "react";

import BusinessCardHeader from "./BusinessCardHeader/BusinessCardHeader";
import BusinessCardBody from "./BusinessCardBody/BusinessCardBody";
import StickyBtn from "../StickyBtn/StickyBtn";
import Modal from "../Modal/Modal";

import styles from "./business-card.module.scss";

const BusinessCard = (props) => {
  const [isModal, setIsModal] = useState(false);

  document.title = props.data.name;

  const handleModal = (e) => {
    e.stopPropagation();
    setIsModal((isModal) => !isModal)
  }

  return (
    <div className={styles.business_card}>
      <BusinessCardHeader data={props.data}/>
      <BusinessCardBody data={props.data}/>
      <StickyBtn openModal={handleModal} />
      {isModal ? <Modal closeModal={handleModal} data={props.data}/> : null}
    </div>
  );
};

export default BusinessCard;
